const queryParameters = {
	Filter: 'f',
	DeviceModelName: 'device-model',
	DeviceState: 'device-state',
	EndDate: 'end-date',
	KeyType: 'key-type',
	Language: 'lang',
	LockState: 'lock-state',
	OrderBy: 'order',
	OrganisationId: 'organisation-id',
	OverwrittenClientId: 'overwritten-client-id',
	Page: 'page',
	PageSize: 'size',
	ResourceGroupId: 'resource-group-id',
	Role: 'role',
	SearchQuery: 'q',
	SortBy: 'sort',
	StartDate: 'start-date',
	User: 'u',
} as const;

export default queryParameters;
